'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  // TODO: Нужно заменить на другой URL
  fetchAverageTime (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/analytics/response-average-recruitment-duration-table', { params })
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchTotalVideointerviewDuration (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/analytics/video_interview/duration', { params })
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchFunnel (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/analytics/response-status-funnel', { params })
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchPieChartStatuses (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/analytics/response-status-count', { params })
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchRecruitersTable (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/analytics/user-response-summary-table', { params })
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  },

  exportRecruitersTableToExcel (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/analytics/user-response-summary-table-excel', { params })
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  },

  exportVacanciesTableToExcel (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/analytics/vacancy-response-summary-table-excel', { params })
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  },

  fetchStatuses(params) {
    return Axios.get(`1.0/analytics/analytics-response-statuses`)
      .then(response => parseResponse(response).data)
      .catch(err => Promise.reject(handleError(err)))
  },

  updateStatuses(params) {
    let data = { analytics_statuses: params }

    return Axios.put(`1.0/analytics/analytics-response-statuses`, data)
      .then(response => parseResponse(response).data)
      .catch(err => Promise.reject(handleError(err)))
  }
}
